import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Checkbox,
  FormControlLabel,
  Box
} from '@mui/material';
import { updateFileAccess } from '../../api/fileAPI';
import { useTranslation } from 'react-i18next';

interface ModalFilePermissionsProps {
  open: boolean;
  onClose: () => void;
  fileId: string;
  fileName: string;
  initialView: boolean;
  initialDownload: boolean;
}

const ModalFilePermissions: React.FC<ModalFilePermissionsProps> = ({
  open,
  onClose,
  fileId,
  fileName,
  initialView,
  initialDownload,
}) => {
  const [view, setView] = useState(initialView);
  const [download, setDownload] = useState(initialDownload);
  const { t, i18n } = useTranslation();
    
  useEffect(() => {
    const storedLang = localStorage.getItem('language') || 'EN';
    i18n.changeLanguage(storedLang);
  }, []);

  useEffect(() => {
    if (open) {
      setView(initialView);
      setDownload(initialDownload);
    }
  }, [open, initialView, initialDownload]);

  const handleSave = async () => {
    try {
      await updateFileAccess(fileId, view, download);
      onClose();
    } catch (err) {
      console.error('Error updating file access:', err);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t('permissionsFor')} {fileName}</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <FormControlLabel
            control={<Checkbox checked={view} onChange={(e) => setView(e.target.checked)} />}
            label="View"
          />
          <FormControlLabel
            control={<Checkbox checked={download} onChange={(e) => setDownload(e.target.checked)} />}
            label="Download"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('cancel')}</Button>
        <Button onClick={handleSave} variant="contained" sx={{ backgroundColor: '#73AF73' }}>
          {t('save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalFilePermissions;